import { CountryCodes } from '@/enums/general'

type CountryPrices = Record<(typeof CountryCodes)[keyof typeof CountryCodes], number>

export const MenPrices: CountryPrices = Object.freeze({
  [CountryCodes.austria]: 12.99,
  [CountryCodes.belgium]: 12.99,
  [CountryCodes.switzerland]: 12.99,
  [CountryCodes.czechRepublic]: 259.99,
  [CountryCodes.germany]: 12.99,
  [CountryCodes.denmark]: 106.99,
  [CountryCodes.spain]: 12.99,
  [CountryCodes.finland]: 12.99,
  [CountryCodes.france]: 12.99,
  [CountryCodes.unitedKingdom]: 12.99,
  [CountryCodes.ireland]: 12.99,
  [CountryCodes.italy]: 12.99,
  [CountryCodes.luxembourg]: 12.99,
  [CountryCodes.netherlands]: 12.99,
  [CountryCodes.norway]: 141.99,
  [CountryCodes.poland]: 53.99,
  [CountryCodes.portugal]: 12.99,
  [CountryCodes.sweden]: 134.99
})

export const BoysPrices: CountryPrices = Object.freeze({
  [CountryCodes.austria]: 10.99,
  [CountryCodes.belgium]: 10.99,
  [CountryCodes.switzerland]: 10.99,
  [CountryCodes.czechRepublic]: 236.99,
  [CountryCodes.germany]: 10.99,
  [CountryCodes.denmark]: 96.99,
  [CountryCodes.spain]: 10.99,
  [CountryCodes.finland]: 10.99,
  [CountryCodes.france]: 10.99,
  [CountryCodes.unitedKingdom]: 10.99,
  [CountryCodes.ireland]: 10.99,
  [CountryCodes.italy]: 10.99,
  [CountryCodes.luxembourg]: 10.99,
  [CountryCodes.netherlands]: 10.99,
  [CountryCodes.norway]: 131.99,
  [CountryCodes.poland]: 48.99,
  [CountryCodes.portugal]: 10.99,
  [CountryCodes.sweden]: 124.99
})

export const SocksDiscountPrices: CountryPrices = Object.freeze({
  [CountryCodes.austria]: 5.99,
  [CountryCodes.belgium]: 5.99,
  [CountryCodes.switzerland]: 6.99,
  [CountryCodes.czechRepublic]: 142.99,
  [CountryCodes.germany]: 5.99,
  [CountryCodes.denmark]: 44.99,
  [CountryCodes.spain]: 5.99,
  [CountryCodes.finland]: 5.99,
  [CountryCodes.france]: 5.99,
  [CountryCodes.unitedKingdom]: 5.99,
  [CountryCodes.ireland]: 5.99,
  [CountryCodes.italy]: 5.99,
  [CountryCodes.luxembourg]: 5.99,
  [CountryCodes.netherlands]: 5.99,
  [CountryCodes.norway]: 82.99,
  [CountryCodes.poland]: 27.99,
  [CountryCodes.portugal]: 5.99,
  [CountryCodes.sweden]: 62.99
})

export const UndershirtsDiscountPrices: CountryPrices = Object.freeze({
  [CountryCodes.austria]: 7.99,
  [CountryCodes.belgium]: 7.99,
  [CountryCodes.switzerland]: 7.99,
  [CountryCodes.czechRepublic]: 201.99,
  [CountryCodes.germany]: 7.99,
  [CountryCodes.denmark]: 63.99,
  [CountryCodes.spain]: 7.99,
  [CountryCodes.finland]: 7.99,
  [CountryCodes.france]: 7.99,
  [CountryCodes.unitedKingdom]: 7.99,
  [CountryCodes.ireland]: 7.99,
  [CountryCodes.italy]: 7.99,
  [CountryCodes.luxembourg]: 7.99,
  [CountryCodes.netherlands]: 7.99,
  [CountryCodes.norway]: 106.99,
  [CountryCodes.poland]: 33.99,
  [CountryCodes.portugal]: 7.99,
  [CountryCodes.sweden]: 90.99
})

export const NewPriceCountries: (typeof CountryCodes)[keyof typeof CountryCodes][] = [
  CountryCodes.austria,
  CountryCodes.belgium,
  CountryCodes.denmark,
  CountryCodes.germany,
  CountryCodes.spain,
  CountryCodes.france,
  CountryCodes.netherlands,
  CountryCodes.unitedKingdom,
  CountryCodes.sweden,
  CountryCodes.italy,
  CountryCodes.poland,
  CountryCodes.switzerland,
  CountryCodes.ireland,
  CountryCodes.luxembourg,
  CountryCodes.portugal,
  CountryCodes.finland,
  CountryCodes.norway,
  CountryCodes.czechRepublic
]

// Prices for Loyalty Specials
export const LoyaltySpecialsBannerRetailPrices: CountryPrices = {
  [CountryCodes.austria]: 59.99,
  [CountryCodes.belgium]: 59.99,
  [CountryCodes.denmark]: 448.99,
  [CountryCodes.germany]: 59.99,
  [CountryCodes.spain]: 59.99,
  [CountryCodes.france]: 59.99,
  [CountryCodes.netherlands]: 59.99,
  [CountryCodes.unitedKingdom]: 51.99,
  [CountryCodes.sweden]: 652.99,
  [CountryCodes.italy]: 59.99,
  [CountryCodes.poland]: 254.99,
  [CountryCodes.switzerland]: 54.99,
  [CountryCodes.ireland]: 59.99,
  [CountryCodes.luxembourg]: 59.99,
  [CountryCodes.portugal]: 59.99,
  [CountryCodes.finland]: 59.99,
  [CountryCodes.norway]: 649.99,
  [CountryCodes.czechRepublic]: 1459.99
}

export const LoyaltySpecialsBannerPrices: CountryPrices = {
  [CountryCodes.austria]: 17.99,
  [CountryCodes.belgium]: 17.99,
  [CountryCodes.denmark]: 134.99,
  [CountryCodes.germany]: 17.99,
  [CountryCodes.spain]: 17.99,
  [CountryCodes.france]: 17.99,
  [CountryCodes.netherlands]: 17.99,
  [CountryCodes.unitedKingdom]: 15.99,
  [CountryCodes.sweden]: 195.99,
  [CountryCodes.italy]: 17.99,
  [CountryCodes.poland]: 76.99,
  [CountryCodes.switzerland]: 16.99,
  [CountryCodes.ireland]: 17.99,
  [CountryCodes.luxembourg]: 17.99,
  [CountryCodes.portugal]: 17.99,
  [CountryCodes.finland]: 17.99,
  [CountryCodes.norway]: 194.99,
  [CountryCodes.czechRepublic]: 437.99
}
